
// You can write more code here

/* START OF COMPILED CODE */

import ChunkBase from "../../ChunkBase";
import ChunkBoundaries from "../../../components/ChunkBoundaries";
import BoundsMarker from "../../editor/BoundsMarker";
import DecorationCaveChest from "../../decorations/cave/DecorationCaveChest";
import CheckpointMarker from "../../editor/CheckpointMarker";
import PlatformMarkerGroundLavaLong from "../../editor/platform-markers/cave/PlatformMarkerGroundLavaLong";
import FinishMarker from "../../editor/FinishMarker";
/* START-USER-IMPORTS */
/* END-USER-IMPORTS */

export default class CaveEndChunk extends ChunkBase {

  constructor(scene: Phaser.Scene, x?: number, y?: number) {
    super(scene, x ?? 367.8941131276538, y ?? 592.0721129292459);

    // editor_bounds_left
    const editor_bounds_left = new BoundsMarker(scene, -521.8941040039062, -136.07208251953125);
    this.add(editor_bounds_left);

    // editor_bounds_right
    const editor_bounds_right = new BoundsMarker(scene, 1391, -136);
    this.add(editor_bounds_right);

    // decorationCaveChest
    const decorationCaveChest = new DecorationCaveChest(scene, 80, -511);
    this.add(decorationCaveChest);

    // checkpointMarker
    const checkpointMarker = new CheckpointMarker(scene, -387, -220);
    this.add(checkpointMarker);

    // platformMarkerGroundLavaLong
    const platformMarkerGroundLavaLong = new PlatformMarkerGroundLavaLong(scene, 62, -157);
    this.add(platformMarkerGroundLavaLong);

    // finishMarker
    const finishMarker = new FinishMarker(scene, 99, -241);
    this.add(finishMarker);

    // this (components)
    const thisChunkBoundaries = new ChunkBoundaries(this);
    thisChunkBoundaries.leftBoundsMarker = editor_bounds_left;
    thisChunkBoundaries.rightBoundsMarker = editor_bounds_right;

    /* START-USER-CTR-CODE */
    // Write your code here.
    /* END-USER-CTR-CODE */
  }

  /* START-USER-CODE */

  // Write your code here.

  /* END-USER-CODE */
}

/* END OF COMPILED CODE */

// You can write more code here
